import { Box, Typography } from "@mui/material";
import { FC, useState } from "react";

import ChallanReportsTab from "./ChallanReportsTab";
import DashboardTab from "./DashboardTab";
import "./index.css";

enum DASHBOARD_TAB_E {
	DASHBOARD,
	CHALLAN
}

const Dashboard: FC = () => {
	const [activeTab, setActiveTab] = useState<DASHBOARD_TAB_E>(DASHBOARD_TAB_E.DASHBOARD);

	return (
		<Box className="page-content-wrapper">
			{/* Tab Navigation */}
			<Box className="dashboard-tab-selection-wrapper">
				{[DASHBOARD_TAB_E.DASHBOARD, DASHBOARD_TAB_E.CHALLAN].map((tab) => {
					const tabLabels = {
						[DASHBOARD_TAB_E.DASHBOARD]: "Dashboard",
						[DASHBOARD_TAB_E.CHALLAN]: "Challan Reports"
					};

					return (
						<Box
							key={tab}
							onClick={() => setActiveTab(tab)}
							className={`dashboard-tab-button ${activeTab === tab ? "active" : ""}`}
						>
							<Typography sx={{ fontWeight: 500, fontSize: 15 }}>{tabLabels[tab as keyof typeof tabLabels]}</Typography>
						</Box>
					);
				})}
			</Box>

			{/* Tab Content */}
			{activeTab === DASHBOARD_TAB_E.DASHBOARD ? <DashboardTab /> : <ChallanReportsTab />}
		</Box>
	);
};

export default Dashboard;
